import React from 'react';
import { Cart as CartComponent } from '@/components/cart/Cart';

export const Cart: React.FC = () => {
  return <CartComponent />;
};
